import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface PerformanceMatch {
    athlete_name: string;
    member_uuid: string;
    event: string;
    mark: string;
    school?: string;
    year?: string;
    date?: string;
    location?: string;
    meet_name?: string;
}

interface ImportRequest {
    group_uuid: string;
    matches: PerformanceMatch[];
    import_url?: string;
}

interface ImportResponse {
    success: boolean;
    imported_count: number;
    message: string;
}

type ReturnType = Promise<AxiosResponse<ImportResponse>>;

const confirmTrackEventImport = (data: ImportRequest): ReturnType => {
    return Request.post('/workouts/track-events/import', data);
};

export default confirmTrackEventImport;
